
import { Component, Inject, Input, NgZone } from '@angular/core';

@Component({
  templateUrl: './telemetry.component.html',
})
export class SystemHealthTelemetryComponent {
  constructor() {
  }
}
